import React from "react";
import { Location } from "../../data";
import { useI18n } from "../../lib/i18n/i18n_provider";

interface DirectionsProps {
  location: Location;
}

export function Directions(props: DirectionsProps) {
  const { location } = props;
  const { name, streetAddress, city, direction } = location;
  const { fbt } = useI18n();

  return (
    <div data-testid="directions" className="directions">
      <h3 className="directions__title">{fbt("Directions")}</h3>
      {direction ? (
        <div
          dangerouslySetInnerHTML={{
            __html: direction,
          }}
        />
      ) : (
        `${name} ${fbt("is located at")} ${streetAddress}, ${city}`
      )}
    </div>
  );
}
